import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import StarRating from "./StarRating";

const Feedback = ({ reviews }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 576) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }

      if (width >= 1200) {
        setItemsPerPage(3);
      } else if (width >= 768) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!reviews || reviews.length === 0) return null;

  const totalPages = Math.ceil(reviews.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentReviews = reviews.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <div className="row mt-4">
      <div className="col-12">
        <div>
          <h4 style={{ marginBottom: "20px" }}>
            What Guests Are Saying
          </h4>

          {/*. MOBILE (CAROUSEL) */}
          {isMobile ? (
            <Swiper
              modules={[Pagination]}
              spaceBetween={15}
              slidesPerView={1}
              pagination={{ clickable: true }}
            >
              {reviews.map((review, idx) => (
                <SwiperSlide key={idx}>
                  <div
                    style={{
                      width: "100%",   // 🔥 FIX
                      minHeight: "180px", // 🔥 keeps size consistent
                      border: "1px solid #eee",
                      borderRadius: "10px",
                      padding: "15px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ flexGrow: 1 }}>
                      <StarRating value={Number(review.rating)} />
                      <p>“ {review.review} ”</p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "15px",
                      }}
                    >
                      {review.reviewer_avatar_url ? (
                        <img
                          src={review.reviewer_avatar_url}
                          alt={review.reviewer_name}
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginRight: "10px",
                          }}
                        />
                      ) : (
                        <span
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            background: "#373758",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "10px",
                            fontWeight: 700,
                          }}
                        >
                          {(review.reviewer_name || "G").charAt(0).toUpperCase()}
                        </span>
                      )}

                      <div>
                        <h4 style={{ margin: 0 }}>
                          {review.reviewer_name || "Guest"}
                          {review.verified && <span className="verified-pill">✓ Verified</span>}
                        </h4>
                        {review.location && (
                          <p style={{ margin: 0 }}>
                            {review.location}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <>
              {/*. DESKTOP/TABLET GRID */}
              <div className="row gx-3">
                {currentReviews.map((review, idx) => (
                  <div
                    key={idx}
                    className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-3 d-flex"
                  >
                    <div
                      style={{
                        border: "1px solid #eee",
                        borderRadius: "10px",
                        padding: "15px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flexGrow: 1 }}>
                        <StarRating value={Number(review.rating)} />
                        <p>“ {review.review} ”</p>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "15px",
                        }}
                      >
                        {review.reviewer_avatar_url ? (
                          <img
                            src={review.reviewer_avatar_url}
                            alt={review.reviewer_name}
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                        ) : (
                          <span
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                              background: "#373758",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "10px",
                              fontWeight: 700,
                            }}
                          >
                            {(review.reviewer_name || "G").charAt(0).toUpperCase()}
                          </span>
                        )}

                        <div>
                          <h4 style={{ margin: 0 }}>
                            {review.reviewer_name || "Guest"}
                            {review.verified && <span className="verified-pill">✓ Verified</span>}
                          </h4>
                          {review.location && (
                            <p style={{ margin: 0 }}>
                              {review.location}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/*. PAGINATION */}
              {totalPages > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <ul
                    style={{
                      display: "flex",
                      gap: "10px",
                      listStyle: "none",
                      padding: 0,
                    }}
                  >
                    {[...Array(totalPages)].map((_, i) => (
                      <li key={i}>
                        <button
                          onClick={() => setCurrentPage(i + 1)}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            border: "1px solid #373758",
                            background:
                              currentPage === i + 1
                                ? "#373758"
                                : "transparent",
                            color:
                              currentPage === i + 1
                                ? "#fff"
                                : "#373758",
                            cursor: "pointer",
                          }}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Feedback;